// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"d5ac5865","90":"796c6364","421":"56a3b2d3","453":"0c27981b","680":"b6b6d7a1","804":"95099ea8","973":"d004b6de"}[chunkId] + ".chunk.js";
};